import Navbar from "./components/Navbar";
import AppRoutes from "./routes/AppRoutes";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
export default function App() {
  return (
    <>
    
      <TopBar />
      <Navbar />
      
      <AppRoutes />
      <Footer />
    </>
  );
}
